import React from 'react';

import { DangerouslyHtml } from 'apps/promo/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/promo/components/common/Layout/InfoPage/InfoPage';
import { AUTH_SEND_MAIN_LINK } from 'apps/promo/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/promo/hooks/selectors';

const PromoUpgradeLimit = () => {
    const { upgradeLimitTitle, upgradeLimitSubTitle, continueButton, notNowButton } = usePageMessages();
    const { nextPageLink } = useExtra();
    return (
        <InfoPage
            iconName="id-card-80"
            iconColor="purple"
            headerText={<DangerouslyHtml dangerouslyHtml={upgradeLimitTitle} />}
            secondaryText={<DangerouslyHtml dangerouslyHtml={upgradeLimitSubTitle} />}
            topButtonType="link"
            topButtonCaption={notNowButton}
            topButtonLink={AUTH_SEND_MAIN_LINK}
            primaryButtonCaption={continueButton}
            primaryButtonType="link"
            primaryButtonLink={nextPageLink}
        />
    );
};
export default PromoUpgradeLimit;
